var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.204 118.564C175.65 118.564 197.9 96.3141 197.9 68.8678C197.9 41.4216 175.65 19.1719 148.204 19.1719C120.757 19.1719 98.5078 41.4216 98.5078 68.8678C98.5078 96.3141 120.757 118.564 148.204 118.564Z",
    fill: "#00DF67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.037 30.6769V92.03H7.66913V30.6769H115.037ZM122.706 23.0078H0V99.6991H122.706V23.0078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0164 38.3457H15.3398V46.0148H46.0164V38.3457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.368 38.3457H99.6992V46.0148H107.368V38.3457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0285 38.3457H84.3594V46.0148H92.0285V38.3457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6926 38.3457H69.0234V46.0148H76.6926V38.3457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7003 53.6836H15.3398V61.3527H99.7003V53.6836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.368 76.6914H76.6914V84.3605H107.368V76.6914Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.706,
    height: 122.706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.faf5304995cb28e3c91c9989e1528236.svg";
export { ForwardRef as ReactComponent };